// ----------------------------------------------------------------------------
// Component: Rich Text
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_main-headline.scss';
